export const EMAIL_REGEX =
  /^\S+@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6})$/;
export const error_sign = 'assets/images/icn_exclamation_sign.svg';

const BASE_PREQUAL_JSON_URL: string = '/www/get-prequalified/data/';
export const GET_PREQUALIFIED_JSON_URL: string = `${BASE_PREQUAL_JSON_URL}getPrequalifiedLongForm.json`;

export const GET_MARKETING_CONTENT_JSON_URL: string = `${BASE_PREQUAL_JSON_URL}marketingContent.json`;
export const SEO_JSON_URL = '/www/seo/seo.json';
export const GET_PREQUALIFIED_URI: string = '/get-prequalified';

export enum EApplicationStatus {
  ACTIVE = 'ACTIVE',
  PREQUALIFIED = 'PREQUALIFIED',
  CAPS_PREQUALIFIED = 'CAPSPREQUALIFIED',
  QUEUED = 'QUEUED',
  COMPLETED = 'COMPLETED',
  OPEN_LOAN = 'OPEN_LOAN',
  NO_BUREAU_RECORD = 'NO_BUREAU_RECORD',
  FROZEN_BUREAU = 'FROZEN_BUREAU',
  INVALID = 'INVALID',
  INVALID_SSN = 'INVALID_SSN',
  SERVER_ERROR = 'SERVER_ERROR',
  BLOCKED_SSN = 'BLOCKED_SSN',
  ABANDONED = 'ABANDONED',
}

export enum CONSUMER_NAMES {
  'abandonPrequalified',
  'consumerEmail',
  'dealerCaps',
  'dealerRefferal',
  'hotLead',
  'dealerContact',
}
export enum CONSUMER_ERRORS {
  'error',
  'processing_error',
  'timeout_error',
}

export enum EApplicationSteps {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
}

export enum EloquaFormsKeys {
  ABANDON_PREQUALIFIED = 'abandonPrequalified',
  CONSUMER_EMAIL = 'consumerEmail',
  DEALER_CAPS = 'dealerCaps',
  DEALER_REFFERALS = 'dealerRefferals',
}

export enum EErrorCodes {
  NOT_AUTHORIZED = 'Not Authorized',
}
export enum PREQUAL_RESPONSE_TYPE {
  'GENERIC' = 'Generic',
  'MONTHLY_PAYMENT' = 'Monthly_Payment',
}

export const CHANNEL_TYPE = 'CONSUMER - OSM PREQUALIFICATION';
export const CHANNEL_TYPE_HOT_LEAD = 'CONSUMER - OSM HOT LEAD';
export const FORM_NOT_COMPLETED = 'N';
export const NOT_PREQUALIFIED = 'N';
export const PREQUALIFIED = 'Y';
export const FORM_COMPLETED = 'Y';
export const GENERIC_NOTE =
  'This consumer has been pre-qualified through Credit Acceptance. To complete the approval process, please submit a credit application for a specific vehicle.';

export const MAX_AMOUNT_NOTE_PRE =
  'This consumer has been pre-qualified for a monthly payment of up to $';
export const MAX_AMOUNT_NOTE_POST =
  ' through Credit Acceptance. The pre-qualification is valid for 30 days from the date of this note. To complete the approval process, please submit a credit application for a specific vehicle.';
